import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "SOB",
  name: "SOB",
  slug: "sob",
  ...colors,
  pictures: [{ id: "sob_logo.png" }, { id: "sob_logo_black.png" }],
};
export default config;
